const ButtonLarge = (props) => {
  return (
    <button
      type={props.type ? props.type : 'button'}
      onClick={props.disabled ? () => {} : () => props.onClick()}
      className={`${
        props.bold ? 'font-semibold' : 'font-normal'
      } ${props.disabled ? 'bg-borderGray border-2 border-borderGray' : 'bg-red border-2 border-red'}   w-full md:min-w-[140px] flex space-x-2 justify-center items-center px-3 py-3 md:px-5 md:py-3 text-white rounded-2xl text-xl`}>
      {props.icon && (
        <img
          src={props.icon}
          className="w-10 h-10 object-contain"
          alt="icon_login"
        />
      )}

      <span>{props.label}</span>
    </button>
  );
};

export default ButtonLarge;
